
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ErrorAlert from './components/ErrorAlert.vue';
import ExternalLink from './components/ExternalLink.vue';

const Config = namespace('Config');
const Loader = namespace('Loader');

@Component({
  components: { ErrorAlert, ExternalLink },
})
export default class App extends Vue {
  @Config.Action('initialiseConfigState')
  private setInitialConfig!: (data: any) => void;

  @Config.Getter('clientId')
  clientId!: string;

  @Config.Getter('contactUsUrl')
  contactUsUrl!: string;

  @Loader.Getter('isLoading')
  loading!: boolean;

  /**
   * Initialisation step
   * Get data from the URL query params and save it to the store
   */
  mounted(): void {
    this.$router.onReady(() => {
      this.setInitialConfig({
        redirectUri: this.$route.query['redirect-uri']?.toString(),
        clientId: this.$route.query['client-id']?.toString(),
      });
    });
  }

  get clientLogo(): string | null {
    if (!this.clientId) {
      return null;
    }

    try {
      const images = require.context('./assets/', false, /\.png$/);
      return images(`./${this.clientId.toLowerCase()}_logo.png`);
    } catch (e) {
      return null;
    }
  }

  get error(): string | string[] {
    return this.$store.state.error;
  }
}
